import React from 'react';
import { Provider } from 'react-redux'
import generateStore, { history } from './redux/store/index';
import { BrowserRouter } from "react-router-dom";
import {
  App as AppAntd
} from "antd";
import AppRoutes from './routes/Routes';

// CONFIGURAR EL IDIOMA PARA ANTD
import { ConfigProvider } from "antd";
import moment from "moment";
import 'moment/locale/es';
import es_ES from "antd/lib/locale/es_ES";

import './styles/index.css'
import { ThemeProvider } from './context/ThemeContext';

const App: React.FC = () => {

  const store = generateStore()

  return (
    <ConfigProvider 
    theme={{
      token: {
        fontFamily: "Nunito"
      }
      }}
      locale={es_ES}>
      <ThemeProvider>
        <Provider store={store}>
          <BrowserRouter>
            <AppAntd>
              <AppRoutes/>
            </AppAntd>
          </BrowserRouter>
        </Provider>
      </ThemeProvider>
    </ConfigProvider>
  );
}

export default App;
